import type { MarketplaceLead, MinifiedDispensary } from '@gcv/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { BanksApi } from 'api';
import {
  BANK_DISPENSARY_KEY,
  BANK_MARKETPLACE_LEADS_KEY,
  MINIFIED_DISPENSARIES_KEY
} from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';
import { getFiDispensaryStore } from '../../../stores/FiDispensaryStore';

export function useConvertBankMarketplaceLead() {
  const { userBankId } = useUser();
  const banksApi = new BanksApi();
  const queryClient = useQueryClient();

  const { mutateAsync: convertBankMarketplaceLead, isPending: isConvertBankMarketplaceLeadPending } =
    useMutation({
      mutationKey: [BANK_MARKETPLACE_LEADS_KEY],
      mutationFn: async (props: { id: string; template_id: string }) =>
        await banksApi.convertMarketplaceLead(userBankId, props.id, {
          template_id: props.template_id
        }),
      onSuccess: (convertedLead) => {
        const bankMarketplaceLeads: MarketplaceLead[] | undefined = queryClient.getQueryData([
          BANK_MARKETPLACE_LEADS_KEY,
          userBankId
        ]);
        const { lead, dispensary, minifiedDispensary } = convertedLead;
        const existingLead = bankMarketplaceLeads?.findIndex((l) => l.id === lead.id);
        if (existingLead != null && existingLead >= 0) {
          bankMarketplaceLeads?.splice(existingLead, 1, lead);
        }
        queryClient.setQueryData([BANK_MARKETPLACE_LEADS_KEY, userBankId], bankMarketplaceLeads);
        queryClient.setQueryData([BANK_DISPENSARY_KEY, userBankId, dispensary.id], dispensary);

        const minifiedDispensaries: MinifiedDispensary[] | undefined = queryClient.getQueryData([
          MINIFIED_DISPENSARIES_KEY,
          userBankId
        ]);
        minifiedDispensaries?.push(minifiedDispensary);
        queryClient.setQueryData([MINIFIED_DISPENSARIES_KEY, userBankId], minifiedDispensaries);

        // TODO won't be neccessary after removal of stores
        getFiDispensaryStore().addDispensary(minifiedDispensary);
      }
    });

  return { convertBankMarketplaceLead, isConvertBankMarketplaceLeadPending };
}
